import React, { useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'components/CheckboxNew';
import { useExaminationsActions, useAlerts, FILE_ID, FILE_URL, FILE_URL_EXPIRES, BUCKET, MIMETYPE } from 'store/examinations';

import { Container, CheckBoxContainer, Field } from './styles';

const Row = ({
  id: reportId,
  widths,
  patientName,
  birth,
  reportDate,
  status,
  markers,
  url,
  fileData,
  onCheckBoxClick,
  updateReportStatus,
}) => {
  const { loadFile } = useExaminationsActions();
  const { action, loading, success, resetAlerts } = useAlerts(loadFile);
  const selected = useMemo(() => markers.includes(reportId), [markers, reportId]);

  const handleCheckBoxClick = useCallback(() => onCheckBoxClick(reportId), [onCheckBoxClick, reportId]);
  const handleClick = useCallback(() => {
    if (loading) return;
    if (fileData?.[FILE_ID]) {
      action(fileData);
    } else if (url) {
      window.open(url, '_blank');
      updateReportStatus({ reportId, status });
    }
  }, [action, fileData, loading, reportId, status, updateReportStatus, url]);

  const fieldProps = useMemo(() => ({ status, onClick: handleClick }), [status, handleClick]);

  useEffect(() => {
    if (success) {
      window.open(success, '_blank');
      resetAlerts();
      updateReportStatus({ reportId, status });
    }
  }, [reportId, resetAlerts, status, success, updateReportStatus]);

  return (
    <Container key={reportId}>
      <CheckBoxContainer width={widths[0]} onClick={handleCheckBoxClick}>
        <Checkbox selected={selected} size={14} mr={0} mb={0} iconType="darkCheck" borderColor="var(--color-grey6A)" />
      </CheckBoxContainer>
      <Field width={widths[1]} {...fieldProps}>
        {patientName}
      </Field>
      <Field width={widths[2]} {...fieldProps}>
        {birth}
      </Field>
      <Field width={widths[3]} {...fieldProps}>
        {reportDate}
      </Field>
    </Container>
  );
};

Row.defaultProps = {
  patientName: '',
  birth: '',
  reportDate: '',
  markers: [],
  url: null,
  fileData: null,
};

Row.propTypes = {
  id: PropTypes.string.isRequired,
  widths: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  markers: PropTypes.arrayOf(PropTypes.string),
  patientName: PropTypes.string,
  birth: PropTypes.string,
  reportDate: PropTypes.string,
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  url: PropTypes.string,
  fileData: PropTypes.shape({
    [FILE_ID]: PropTypes.string,
    [FILE_URL]: PropTypes.string,
    [FILE_URL_EXPIRES]: PropTypes.string,
    [BUCKET]: PropTypes.string,
    [MIMETYPE]: PropTypes.string,
  }),
  onCheckBoxClick: PropTypes.func.isRequired,
  updateReportStatus: PropTypes.func.isRequired,
};

export default Row;
